import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useDispatchTrackEvent } from "@grandvisionhq/svc-tealium/events";
import { NonRxProductAddToCartButton } from "../../../../../../NonRxProductAddToCartButton/modules/EcommContent/components/CTAs/NonRxProductAddToCartButton/NonRxProductAddToCartButton.js";
const NonRxProductCTA = ({
  action,
  addToCartConfig,
  storesRoute,
  handleConversionEvent,
  ...tealiumProps
}) => {
  const { getLabel } = useIntl();
  const dispatchTrackEvent = useDispatchTrackEvent();
  const findStoreOpenEvent = () => Promise.resolve({
    id: "Impression",
    Page_Section2: "FisPdp",
    Events_FindStoreOpen: "1"
  });
  const onHandleClick = () => {
    dispatchTrackEvent(findStoreOpenEvent);
    handleConversionEvent?.();
  };
  if (action === "ADD_TO_CART") {
    return /* @__PURE__ */ React.createElement(NonRxProductAddToCartButton, { ...addToCartConfig, ...tealiumProps });
  }
  const findInStoreTealiumAttributes = {
    "data-element-id": "Prod_FindInStore"
  };
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: onHandleClick,
      caption: getLabel("products.actions.excludedFromCheckout"),
      "data-t": "btn-excluded-from-checkout",
      href: storesRoute,
      ...findInStoreTealiumAttributes
    }
  );
};
export {
  NonRxProductCTA
};
//# sourceMappingURL=NonRxProductCTA.js.map
